import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { clearField, getError, InputTableFilter, SmartFormContainer } from '@shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-filter',
  templateUrl: './input-filter.component.html',
  styleUrls: ['./input-filter.component.scss'],
})
export class InputFilterComponent extends SmartFormContainer implements OnInit, OnDestroy {
  readonly getError = getError;
  readonly clearField = clearField;

  private inputSubscription: Subscription = null;

  @Input() config: InputTableFilter;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  get tooltip(): string {
    return this.config.tooltipCallback ? this.config.tooltipCallback(this.form) : '';
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initSubscription();
  }

  initSubscription(): void {
    if (this.inputSubscription || !this.config.valueChangeSubscription) {
      return;
    }

    this.inputSubscription = this.config.valueChangeSubscription(this);
  }

  ngOnDestroy(): void {
    this.inputSubscription?.unsubscribe();
  }
}
